import { useEffect, useState, useRef } from "react";

import Image from "next/image";
import Slider from "react-slick";

import { AxiosInstance } from "../../../utilities";
import testmonialStyles from "../../HomeComponent/TestimonialComponent/TestimonialComponent.module.css";
import styles from "./MiniTestimonialComponent.module.css";

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        dots: true,
        arrows: false,
      },
    },
  ],
};

export default function MiniTestimonialComponent(props) {
  const [testimonials, setTestimonials] = useState([]);
  const bgRef = useRef(null);

  // Lazy load the testimonial background image
  useEffect(() => {
    if (bgRef.current) {
      const observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const el = entry.target;
              const bgUrl = el.getAttribute("data-bg");
              if (bgUrl) {
                el.style.backgroundImage = `url('${bgUrl}')`;
                observerInstance.unobserve(el);
              }
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(bgRef.current);
      return () => {
        observer.disconnect();
      };
    }
  }, []);

  // Fetch testimonials
  useEffect(() => {
    const fetch_homepage_cms_data = () => {
      AxiosInstance(4008, "application/json")
        .post("/pages", { slug: "home" })
        .then((resp) => {
          const response = resp && resp.data;
          if (
            response &&
            (response.status === 200 || response.status === "200")
          ) {
            const response_Data = response.data;
            response_Data &&
              response_Data.data.forEach((item) => {
                if (item.key === "testimonials") {
                  setTestimonials(item.content);
                }
              });
          }
        })
        .catch((err) => {
          console.log("err---", err?.message);
        });
    };
    fetch_homepage_cms_data();
  }, []);

  return (
    <section
      className={`${testmonialStyles.testimonial_container} ${styles.mini_testi_container}`}
    >
      {/* The background container now uses a ref and data attribute for lazy loading */}
      <div
        ref={bgRef}
        className={`${testmonialStyles.testimonial_container_bg} ${styles.mini_testi_bg}`}
        data-bg="/assets/images/testimonial_bg.svg"
      ></div>
      <div className={testmonialStyles.conatiner_fluid}>
        <div className={testmonialStyles.testimonial_heading_section}>
          <h2 className={testmonialStyles.testimonial_heading}>
            {props.testimonials_heading
              ? props.testimonials_heading
              : "Testimonials"}
          </h2>
        </div>
        <div className={testmonialStyles.testimonial_slider}>
          <Slider {...settings}>
            {testimonials &&
              testimonials.length > 0 &&
              testimonials.map((item) => (
                <div key={item._id}>
                  <div className={testmonialStyles.testimonial_slide}>
                    <figure className={styles.testimonial_slide_figure}>
                      <Image
                      loading="lazy"
                        src={
                          item.value !== ""
                            ? process.env.IMAGE_LINK + item.value
                            : "/assets/images/empty_image_placeholder.jpg"
                        }
                        alt=""
                        width={631}
                        height={501}
                      />
                    </figure>
                    <div className={testmonialStyles.testimonial_slide_content}>
                      <div>
                        <p
                          className={
                            testmonialStyles.testimonial_slide_content_para
                          }
                        >
                          {item.description}
                        </p>
                        <h6
                          className={
                            testmonialStyles.testimonial_slide_content_heading
                          }
                        >
                          {item.title}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
